import {
  CLEAR_ACTIVE_MENU,
  GET_ACTIVE_MENU,
  SET_ACTIVE_MENU,
  SET_ACTIVE_CHILD_MENU,
} from "./ActiveMenuType";

const initialState = {
  activeMenu: "",
  activeChildMenu: "",
};

const ActiveMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_MENU:
      return {
        ...state,
      };
    case SET_ACTIVE_CHILD_MENU:
      return {
        ...state,
        activeChildMenu: action.payload,
      };
    case SET_ACTIVE_MENU:
      return {
        ...state,
        activeMenu: action.payload,
        activeChildMenu: action.payload.activeChildMenu,
      };
    case CLEAR_ACTIVE_MENU:
      return {
        ...state,
        activeMenu: null,
        activeChildMenu: null,
      };
    default:
      return state;
  }
};

export default ActiveMenuReducer;
